import {MODES} from "../app/services/constants";

export const environment = {
  production: true,
  appId: 70,
  apiUrl: 'https://apps-stg.theguru.co/api/',
  currentContext: MODES.EXPLORE,
  disableCaptcha: false
};
